import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { withRouter } from "../../../providers/withRouter";
import { useNavigate } from "react-router-dom";
import { Box, TextField, Typography } from "@mui/material";
import {
  LaeButton,
  PropertieSelector,
  ServiceToSaleSelector,
} from "../../../components";
import { createSale } from "../../../services";
import { toast } from "react-toastify";
import { formatoFechas } from "../../../functions/funciones";
import Swal from "sweetalert2";

const CrearVenta = (props) => {
  const { t } = useTranslation(['common', 'properties']);
  const navigate = useNavigate();
  const [propertieDrawer, setPropertieDrawer] = useState(false);
  const [serviceDrawer, setServDrawer] = useState(false);
  const [fecha, setFecha] = useState(formatoFechas(new Date()));

  const [propertieInfo, setPropertieInfo] = useState({});
  const [serviceInfo, setServiceInfo] = useState({
    id: "",
    name: "",
  });

  const openPropertieDrawer = () => setPropertieDrawer(true);
  const openServiceDrawer = () => setServDrawer(true);
  const getFecha = (e) => {
    setFecha(e.target.value);
  };

  const closePropertieDrawer = (row) => {
    if (row.data) {
      const {
        finca: { workSales: centrosTrabajo },
        aaff: { id: aaff_id, commer_id: commer_id, tech_id: tech_id },
        id_main_property,
        community: community_name,
        isWorkcenter,
        id,
      } = row.data;
      // console.log(row.data);
      setPropertieInfo({
        prop_id: id_main_property,
        workcenter_id: isWorkcenter ? id : null,
        name: community_name,
        aaff_id: aaff_id,
        commer_id: commer_id,
        centrosTrabajo: centrosTrabajo,
      });
    }

    setPropertieDrawer(false);
  };

  const closeServiceDrawer = (row) => {
    if (row.data) {
      const { service_name, id } = row.data;
      setServiceInfo((prev) => ({
        id,
        name: `${service_name}`,
      }));
    }

    setServDrawer(false);
  };

  const saveSale = async () => {
    let toastInfo = toast.info(t('services.messages.creatingSale'), { autoClose: false });
    let data = {};

    if (propertieInfo.prop_id) {
      data = {
        aaff_id: propertieInfo.aaff_id,
        prop_id: propertieInfo.prop_id,
        workcenter_id: propertieInfo.workcenter_id,
        commer_id: propertieInfo.commer_id,
        servp_id: serviceInfo.id,
        saleDate: fecha,
      };
    }
    let itemsErr = {};

    try {
      let errores = false;

      if (new Date(data.saleDate).getTime() > new Date().getTime()) {
        toast.update(toastInfo, {
          render: t('services.messages.futureDateError'),
          type: toast.TYPE.ERROR,
          autoClose: true,
        });
        return;
      }
      const response = await createSale(data);

      if (response.status === 200 && errores === false) {
        toast.update(toastInfo, {
          render: response.msg,
          type: toast.TYPE.SUCCESS,
          autoClose: true,
        });
        setTimeout(() => {
          navigate("/servicios");
        }, 2000);
      } else {
        if (response.status === 400) {
          if (response.msg) {
            itemsErr = response.msg;
          } else {
            itemsErr = response.data.error;
          }
          toast.dismiss(toastInfo);
          errores = true;
        } else {
          itemsErr = response.error;
          toast.dismiss(toastInfo);
          errores = true;
        }

        const html = `
        <div style="display: flex;">
            <div style="flex: 1;">
                <ul style="font-size:13px; margin-top:10px; text-align:left;">
                    ${`<li style="margin:5px 0;">${itemsErr}</li>`}
                </ul>
            </div>
        </div>
    `;
        // console.log(itemsErr);
        Swal.fire({
          title: t('services.messages.createError'),
          html: html,
          confirmButtonText: t('actions.close'),
          icon: "error",
        });
      }
    } catch (err) {
      console.log(err);
      toast.error(t('services.messages.emptyFieldsError'));
      toast.dismiss(toastInfo);
    }
  };

  return (
    <>
      <PropertieSelector
        open={propertieDrawer}
        onClose={closePropertieDrawer}
      />

      <ServiceToSaleSelector
        open={serviceDrawer}
        onClose={closeServiceDrawer}
      />
      <div
        className="pageHeader"
        style={{ backgroundColor: "#f6f7fb", alignContent: "center" }}
      >
        <Typography variant="h4" color="#212529" fontWeight={"bold"}>
          {t('services.create')}
        </Typography>
      </div>
      <Box
        className="pageContent"
        sx={{
          maxWidth: 900,
          margin: "0 auto",
          p: 4,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            mb: 10,
            maxWidth: 700,
            margin: "0 auto",
          }}
        >
          <Typography variant="h4" sx={{ mb: 2 }}>
            {t('services.saleDetails')}
          </Typography>
          <Box display={"flex"} flexDirection={"row"} flex={1} gap={2}>
            <TextField
              id="propertie-selector"
              label={propertieInfo.workcenter_id ? t('properties:workCenter.title') : t('properties:titleSingular')}
              placeholder={t('properties:titleSingular')}
              variant="outlined"
              InputProps={{
                readOnly: true,
              }}
              value={propertieInfo.name ?? ""}
              onClick={openPropertieDrawer}
              fullWidth
            />
          </Box>

          <Box display={"flex"} flexDirection={"row"} flex={1} gap={2}>
            <TextField
              id="service-selector"
              placeholder={t('services.serviceToHire')}
              label={t('form.service')}
              variant="outlined"
              InputProps={{
                readOnly: true,
              }}
              value={serviceInfo.name}
              onClick={openServiceDrawer}
              fullWidth
            />
          </Box>
          <Box display={"flex"} flexDirection={"row"} flex={1} gap={2}>
            <TextField
              type="date"
              label={t('form.saleDate')}
              variant="outlined"
              name="fecha"
              value={formatoFechas(new Date(fecha))}
              InputLabelProps={{ shrink: true }}
              onChange={getFecha}
              fullWidth
            />
          </Box>
          <LaeButton
            onClick={() => saveSale()}
            sx={{ width: 700, height: 40, alignSelf: "center" }}
          >
            <Typography>{t('actions.save')}</Typography>
          </LaeButton>
        </Box>
      </Box>
    </>
  );
};

export default withRouter(CrearVenta);
